<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/gaodiyayuanjian" />
          <div class="ProductImages">
              <div class="image-div">
                <div>
                  <p style="font-size: 18px; line-height: 40px">成套柜，接触器，热继电器，断路器等。
                  </p>
                  <img :src="baseApi+ 'upload/product/6001.png'">
                  <img :src="baseApi+ 'upload/product/6002.png'">
                </div>
                <div>
                  <img :src="baseApi+ 'upload/product/6003.png'">
                  <img :src="baseApi+ 'upload/product/6004.png'">
                </div>
              </div>
            <div class="image-div">
                <img style="width: 100%" :src="baseApi+ 'upload/product/6005.png'">
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/view/componets/Banner'
import Tab from '@/views/view/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ProductImages {
  display: flex;
  padding: 30px;
  .image-div {
    width: 50%;
    padding: 10px;
    div {
      img {
        max-width: 30%;
        margin: 0 5%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view/gaodiyayuanjian.vue